import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import Avatar from '@mui/material/Avatar';
import Badge from '@mui/material/Badge';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import ExitToAppOutlinedIcon from '@mui/icons-material/ExitToAppOutlined';
import MailOutlineRoundedIcon from '@mui/icons-material/MailOutlineRounded';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import LocaleSelect from './LocaleSelect';
import LogOut from './LogOut';
import { checkNewMessage } from '../../../actions/misc';

function UserInfo(props) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [logoutOpen, setLogoutOpen] = useState(false);
  const { user, newMessage } = props;

  useEffect(() => {
    props.checkNewMessage();
  }, []);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const openModal = () => {
    setAnchorEl(null);
    setLogoutOpen(prevOpen => !prevOpen);
  };

  const handleLogoutClose = () => {
    setLogoutOpen(false);
  };

  if (!_.isEmpty(user)) {
    return (
      <div>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            // MUI v5+ multiplies numeric gap by theme.spacing (8px), so 30 →
            // 240px. Keep the old 30px visual spacing as an explicit px value.
            gap: '30px',
          }}
        >
          <Link to="/messages">
            <Badge
              overlap="rectangular"
              variant="dot"
              invisible={!newMessage}
              color="error"
              sx={{
                '& .MuiBadge-badge': {
                  width: '17px',
                  height: '17px',
                  minWidth: 0,
                  borderRadius: '50%',
                },
              }}
            >
              <MailOutlineRoundedIcon
                style={{ fill: 'grey', width: '32px', height: '32px' }}
              />
            </Badge>
          </Link>
          <div style={{ marginTop: 7 }}>
            <LocaleSelect />
          </div>
          <Button
            style={{
              borderColor: '#D0DBDB',
              borderRadius: 999,
              textTransform: 'none',
            }}
            variant="outlined"
            onClick={handleClick}
          >
            <Box
              sx={{
                display: 'flex',
                gap: '10px',
              }}
            >
              <Avatar
                style={{ backgroundColor: 'transparent' }}
                src={`${user.avatar?.url}`}
                sx={theme => ({
                  width: theme.spacing(3),
                  height: theme.spacing(3),
                })}
              >
                <AccountCircleIcon />
              </Avatar>
              <span
                style={{
                  fontSize: 15,
                  fontWeight: '600',
                  color: '#545959',
                }}
              >
                {user.full_name}
              </span>
              <KeyboardArrowDownIcon
                sx={anchorEl ? { transform: 'rotate(180deg)' } : undefined}
                style={{ color: '#869191' }}
              />
            </Box>
          </Button>
          <Menu
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleClose}
          >
            <MenuItem onClick={openModal}>
              <Box
                sx={{
                  display: 'flex',
                  gap: '10px',
                }}
              >
                <ExitToAppOutlinedIcon style={{ fill: '#808597' }} />
                <FormattedMessage defaultMessage="Logout" />
              </Box>
            </MenuItem>
          </Menu>
          <LogOut open={logoutOpen} handleClose={handleLogoutClose} />
        </Box>
      </div>
    );
  }
  return <div />;
}

UserInfo.propTypes = {
  user: PropTypes.object,
  newMessage: PropTypes.bool,
};

function mapStateToProps(state) {
  const { newMessage } = state.misc;
  return {
    newMessage,
  };
}

export default connect(mapStateToProps, { checkNewMessage })(UserInfo);
